export const LANDING = '/'
export const RESET_PASSWORD = '/resetpw'
export const ACCOUNT = '/account'
export const ACCOUNT_PROFILE = '/account/profile'
export const ACCOUNT_CHANGE_PW = '/account/change_pw'
export const ACCOUNT_CHANGE_EMAIL = '/account/change_email'
export const ACCOUNT_DELETE = '/account/delete_acc'
